import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as caseTypesActions from './case-types.actions';
import { CaseTypesService } from './case-types.service';

@Injectable()
export class CaseTypesEffects {
    private actions$ = inject(Actions);
    private caseTypesService = inject(CaseTypesService);

    getAllActive$ = createEffect(() =>
        this.actions$.pipe(
            ofType(caseTypesActions.getAll),
            switchMap(() =>
                this.caseTypesService.getAll(true).pipe(
                    map((caseTypes) =>
                        caseTypesActions.getAllSuccess({ caseTypes }),
                    ),
                    catchError((error) =>
                        of(caseTypesActions.getAllFailure({ error })),
                    ),
                ),
            ),
        ),
    );

    getFiltered$ = createEffect(() =>
        this.actions$.pipe(
            ofType(caseTypesActions.getFiltered),
            switchMap((action) =>
                this.caseTypesService
                    .getAll(action.isActive, action.entityType, action.entityId)
                    .pipe(
                        map((caseTypes) =>
                            caseTypesActions.getFilteredSuccess({ caseTypes }),
                        ),
                        catchError((error) =>
                            of(caseTypesActions.getFilteredFailure({ error })),
                        ),
                    ),
            ),
        ),
    );
}
